import { render, staticRenderFns } from "./delegation_entry.vue?vue&type=template&id=ad183564"
import script from "./delegation_entry.vue?vue&type=script&lang=js"
export * from "./delegation_entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports